<template>
    <div>
        <PageLabel :label="$t('Просмотр показаний ПУТЭ')" v-if="$vuetify.breakpoint.smAndUp" />
        <v-row class="page-container mb-3 px-0 mt-4 hidden-sm-and-up">
            <h4 class="textColor fs-16">{{ $t('Список ПУТЭ') }}</h4>
        </v-row>
        <v-row class="page-container mb-3 px-0 mt-4 hidden-sm-and-up">
            <h4 class="textColor fs-14">{{ $t('Просмотр показаний ПУТЭ') }}</h4>
        </v-row>
        <MeterInfo v-if="isMeterAccessable" />
        <MeterIndicationsFilter v-if="isMeterAccessable" />
        <v-row no-gutters v-if="$vuetify.breakpoint.xsOnly">
            <v-col cols="12" sm="12">
                <router-link to="/uploads" class="float-left label font-weight-bold text-16 pt-5 gray--text">{{ $t('Передать показания') }}</router-link>
            </v-col>
        </v-row>
        <MeterIndicationsTable v-if="isMeterAccessable" />
    </div>
</template>
<script>
import PageLabel from '@/components/ui/PageLabel';
import MeterInfo from '@/components/servorgs/meters/MeterInfo';
import MeterIndicationsFilter from '@/components/servorgs/meters/MeterIndicationsFilter';
import MeterIndicationsTable from '@/components/servorgs/meters/MeterIndicationsTable';
import { mapActions } from 'vuex';

export default {
    props: ['id'],
    data: () => ({
        isMeterAccessable: false
    }),
    components: {
        PageLabel,
        MeterInfo,
        MeterIndicationsFilter,
        MeterIndicationsTable
    },
    async created() {
        let access = await this.checkAccessToMeter(this.$route.params.id);
        if (!access.result) {
            this.showMessage({
                color: 'warning',
                message: 'meterAccessDenied',
                messagePayload: { meterID: this.$route.params.id, meterNumber: access.meter_number }
            });
        } else {
            this.isMeterAccessable = true;
        }
    },
    methods: {
        ...mapActions('meters', ['checkAccessToMeter']),
        ...mapActions('base', ['showMessage'])
    }
};
</script>
